import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { productIdField } from './common/productFields';
import { massUnitField } from './common/sharedFields';

export const soldProductRecyclabilityMetadata = {
  displayName: msg({
    message: 'Sold products: Recyclability',
    context: 'Activity data schema name for sold product recyclability',
  }),
  fields: {
    ...coreFields,
    component_id: {
      displayName: msg({
        message: 'Component ID',
        context: 'The ID of the component',
      }),
      externalDescription: msg({
        message: 'The ID of the component',
        context: 'Component ID',
      }),
    },
    component_is_packaging: {
      displayName: msg({
        message: 'Component is packaging',
        context: 'Whether the component of the product is packaging',
      }),
    },
    component_is_recyclable: {
      displayName: msg({
        message: 'Component is recyclable',
        context: 'Whether the component of the product is recyclable',
      }),
    },
    component_weight: {
      displayName: msg({
        message: 'Component weight',
        context: 'The weight of the component',
      }),
      externalDescription: msg({
        message: 'The Weight of an individual unit of the component.',
        context: 'Component weight',
      }),
    },
    component_weight_unit: massUnitField,
    product_id: productIdField,
    products_produced_quantity: {
      displayName: msg({
        message: 'Products produced quantity',
        context: 'The quantity of products produced',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
